var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demonWrapper",class:{ active:_vm.hide }},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demon"},[_c('img',{attrs:{"src":"/img/demon1.png"}})])}]

export { render, staticRenderFns }